import { NgModule } from '@angular/core';
import { IspTranslationPipe } from './isp-translation.pipe';
import { DateFormattingPipe } from './date-formatting.pipe';
import { WhitespaceRemovingPipe } from './whitespace-removing.pipe';
import { StateIconPipe } from './state-icon.pipe';
import { ActionPipe } from './action.pipe';
import { CatalogPipe } from './catalog.pipe';
import { TruncateSpecIdPipe } from './truncate-spec-id.pipe';
import { LocalizedMediumDatePipe } from './localized-medium-date.pipe';
import { FirstCasePipe } from './first-case.pipe';

@NgModule({
    declarations: [IspTranslationPipe, DateFormattingPipe, WhitespaceRemovingPipe, StateIconPipe, ActionPipe, CatalogPipe, TruncateSpecIdPipe, LocalizedMediumDatePipe, FirstCasePipe],
    exports: [IspTranslationPipe, DateFormattingPipe, WhitespaceRemovingPipe, StateIconPipe, ActionPipe, CatalogPipe, TruncateSpecIdPipe, LocalizedMediumDatePipe, FirstCasePipe]
})
export class PipesModule { }